import React, { useContext } from 'react';
import LanguageContext from '../contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { Globe } from 'lucide-react';

const LanguageSelector = () => {
  const { language, changeLanguage } = useContext(LanguageContext);

  const languages = [
    { code: 'FR', label: 'FR', flag: '🇫🇷' },
    { code: 'EN', label: 'EN', flag: '🇬🇧' },
    { code: 'ES', label: 'ES', flag: '🇪🇸' }
  ];

  return (
    <div className="fixed top-4 right-4 z-50 flex items-center gap-1 bg-white/10 backdrop-blur-md rounded-full px-2 py-1 border border-white/20">
      <Globe className="w-3 h-3 text-[#F4C430]" />
      {languages.map((lang) => (
        <Button
          key={lang.code}
          onClick={() => changeLanguage(lang.code)}
          className={`
            px-2 py-0.5 rounded-full text-xs font-semibold transition-all h-6 min-w-0
            ${
              language === lang.code
                ? 'bg-gradient-to-r from-[#D4AF37] to-[#F4C430] text-[#0a2e38]'
                : 'bg-transparent text-white/70 hover:text-white hover:bg-white/10'
            }
          `}
          size="sm"
        >
          <span className="text-xs">{lang.flag}</span>
        </Button>
      ))}
    </div>
  );
};

export default LanguageSelector;
